import { render, staticRenderFns } from "./RichTextBox.vue?vue&type=template&id=eea053a8&scoped=true"
import script from "./RichTextBox.vue?vue&type=script&lang=js"
export * from "./RichTextBox.vue?vue&type=script&lang=js"
import style0 from "./RichTextBox.vue?vue&type=style&index=0&id=eea053a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea053a8",
  null
  
)

export default component.exports